import { gql, TypedDocumentNode } from "@apollo/client";

import {
  ModifyNotesMutation,
  ModifyNotesMutationVariables,
} from "./MarkNotesExported.generated";

const MARK_NOTES_EXPORTED: TypedDocumentNode<
  ModifyNotesMutation,
  ModifyNotesMutationVariables
> = gql`
  mutation modifyNotes($noteUuids: [String], $action: String) {
    modifyNotes(noteUuids: $noteUuids, action: $action) {
      ok
    }
  }
`;

export default MARK_NOTES_EXPORTED;
